import { gql } from '@graphql/__generated__';

export const STEP_RENTAL_LISTINGS_FRAGMENT = gql(/* GraphQL */ `
  fragment StepRentalListings on cma_reports {
    id
    rental_comparables
    rental_comparables_search_params
    is_property_comparable_listings_square_meter_calculation
    include_rental_comparable_listing_details
    rental_comparable_listings_map_zoom_level
    show_full_rental_description
    show_rental_comparable_listing_cards
    property {
      id
      lat
      lng
      computed_surface
      number_of_rooms
      number_of_bedrooms
      locality_place {
        id
      }
      state_place {
        id
      }
      property_type {
        name
        main_type
      }
      latest_appraisal {
        id
        rent_value
      }
    }
  }
`);

export const RENTAL_CMA_LISTINGS = gql(/* GraphQL */ `
  query RentalCmaListings(
    $chWhere: ch_cma_rental_listings_bool_exp!
    $esWhere: es_cma_rental_listings_bool_exp!
    $frWhere: fr_cma_rental_listings_bool_exp!
    $itWhere: it_cma_rental_listings_bool_exp!
    $plWhere: pl_cma_rental_listings_bool_exp!
    $ptWhere: pt_cma_rental_listings_bool_exp!
    $limit: Int!
    $offset: Int = 0
    $ch: Boolean!
    $es: Boolean!
    $fr: Boolean!
    $it: Boolean!
    $pl: Boolean!
    $pt: Boolean!
  ) {
    ch_cma_rental_listings(
      where: $chWhere
      order_by: [{ valid_from: desc }, { id: desc }]
      limit: $limit
      offset: $offset
    ) @include(if: $ch) {
      ...RentalCmaListingCh
    }
    es_cma_rental_listings(
      where: $esWhere
      order_by: [{ valid_from: desc }, { id: desc }]
      limit: $limit
      offset: $offset
    ) @include(if: $es) {
      ...RentalCmaListingEs
    }
    fr_cma_rental_listings(
      where: $frWhere
      order_by: [{ valid_from: desc }, { id: desc }]
      limit: $limit
      offset: $offset
    ) @include(if: $fr) {
      ...RentalCmaListingFr
    }
    it_cma_rental_listings(
      where: $itWhere
      order_by: [{ valid_from: desc }, { id: desc }]
      limit: $limit
      offset: $offset
    ) @include(if: $it) {
      ...RentalCmaListingIt
    }
    pl_cma_rental_listings(
      where: $plWhere
      order_by: [{ valid_from: desc }, { id: desc }]
      limit: $limit
      offset: $offset
    ) @include(if: $pl) {
      ...RentalCmaListingPl
    }
    pt_cma_rental_listings(
      where: $ptWhere
      order_by: [{ valid_from: desc }, { id: desc }]
      limit: $limit
      offset: $offset
    ) @include(if: $pt) {
      ...RentalCmaListingPt
    }
  }
`);

export const RENTAL_CMA_LISTING_CH_FRAGMENT = gql(/* GraphQL */ `
  fragment RentalCmaListingCh on ch_cma_rental_listings {
    id
    address
    locality
    computed_surface
    number_of_rooms
    rent_net_monthly
    gross_rent_monthly
    property_type
    valid_from
    offline_since
    agency_name
    description
    title
    created_at
    geog
    url
    property_main_type
    living_surface
    land_surface
    floor_of_flat
    construction_year
    renovation_year
    number_of_bedrooms
    number_of_bathrooms
    number_of_toilets
    number_of_indoor_parkings
    number_of_outdoor_parkings
    has_view
    has_cellar
    has_elevator
    has_fireplace
    has_storage_room
    has_swimming_pool
    is_child_friendly
    is_wheelchair_accessible
    is_new_development
    agency_contact_address
    agency_contact_person
    images(order_by: { image_index: asc }, limit: 12) {
      id
      bucket_name
      file_name
    }
  }
`);

export const RENTAL_CMA_LISTING_ES_FRAGMENT = gql(/* GraphQL */ `
  fragment RentalCmaListingEs on es_cma_rental_listings {
    id
    address
    locality
    computed_surface
    number_of_rooms
    rent_net_monthly
    gross_rent_monthly
    property_type
    valid_from
    offline_since
    agency_name
    description
    title
    created_at
    geog
    url
    property_main_type
    living_surface
    land_surface
    floor_of_flat
    construction_year
    renovation_year
    number_of_bedrooms
    number_of_bathrooms
    number_of_toilets
    number_of_indoor_parkings
    number_of_outdoor_parkings
    has_view
    has_cellar
    has_elevator
    has_fireplace
    has_storage_room
    has_swimming_pool
    is_child_friendly
    is_wheelchair_accessible
    is_new_development
    agency_contact_address
    agency_contact_person
    images(order_by: { image_index: asc }, limit: 12) {
      id
      bucket_name
      file_name
    }
  }
`);

export const RENTAL_CMA_LISTING_FR_FRAGMENT = gql(/* GraphQL */ `
  fragment RentalCmaListingFr on fr_cma_rental_listings {
    id
    address
    locality
    computed_surface
    number_of_rooms
    rent_net_monthly
    gross_rent_monthly
    property_type
    valid_from
    offline_since
    agency_name
    description
    title
    created_at
    geog
    url
    property_main_type
    living_surface
    land_surface
    floor_of_flat
    construction_year
    renovation_year
    number_of_bedrooms
    number_of_bathrooms
    number_of_toilets
    number_of_indoor_parkings
    number_of_outdoor_parkings
    has_view
    has_cellar
    has_elevator
    has_fireplace
    has_storage_room
    has_swimming_pool
    is_child_friendly
    is_wheelchair_accessible
    is_new_development
    agency_contact_address
    agency_contact_person
    images(order_by: { image_index: asc }, limit: 12) {
      id
      bucket_name
      file_name
    }
  }
`);

export const RENTAL_CMA_LISTING_IT_FRAGMENT = gql(/* GraphQL */ `
  fragment RentalCmaListingIt on it_cma_rental_listings {
    id
    address
    locality
    computed_surface
    number_of_rooms
    rent_net_monthly
    gross_rent_monthly
    property_type
    valid_from
    offline_since
    agency_name
    description
    title
    created_at
    geog
    url
    property_main_type
    living_surface
    land_surface
    floor_of_flat
    construction_year
    renovation_year
    number_of_bedrooms
    number_of_bathrooms
    number_of_toilets
    number_of_indoor_parkings
    number_of_outdoor_parkings
    has_view
    has_cellar
    has_elevator
    has_fireplace
    has_storage_room
    has_swimming_pool
    is_child_friendly
    is_wheelchair_accessible
    is_new_development
    agency_contact_address
    agency_contact_person
    images(order_by: { image_index: asc }, limit: 12) {
      id
      bucket_name
      file_name
    }
  }
`);

export const RENTAL_CMA_LISTING_PL_FRAGMENT = gql(/* GraphQL */ `
  fragment RentalCmaListingPl on pl_cma_rental_listings {
    id
    address
    locality
    computed_surface
    number_of_rooms
    rent_net_monthly
    gross_rent_monthly
    property_type
    valid_from
    offline_since
    agency_name
    description
    title
    created_at
    geog
    url
    property_main_type
    living_surface
    land_surface
    floor_of_flat
    construction_year
    renovation_year
    number_of_bedrooms
    number_of_bathrooms
    number_of_toilets
    number_of_indoor_parkings
    number_of_outdoor_parkings
    has_view
    has_cellar
    has_elevator
    has_fireplace
    has_storage_room
    has_swimming_pool
    is_child_friendly
    is_wheelchair_accessible
    is_new_development
    agency_contact_address
    agency_contact_person
    images(order_by: { image_index: asc }, limit: 12) {
      id
      bucket_name
      file_name
    }
  }
`);

export const RENTAL_CMA_LISTING_PT_FRAGMENT = gql(/* GraphQL */ `
  fragment RentalCmaListingPt on pt_cma_rental_listings {
    id
    address
    locality
    computed_surface
    number_of_rooms
    rent_net_monthly
    gross_rent_monthly
    property_type
    valid_from
    offline_since
    agency_name
    description
    title
    created_at
    geog
    url
    property_main_type
    living_surface
    land_surface
    floor_of_flat
    construction_year
    renovation_year
    number_of_bedrooms
    number_of_bathrooms
    number_of_toilets
    number_of_indoor_parkings
    number_of_outdoor_parkings
    has_view
    has_cellar
    has_elevator
    has_fireplace
    has_storage_room
    has_swimming_pool
    is_child_friendly
    is_wheelchair_accessible
    is_new_development
    agency_contact_address
    agency_contact_person
    images(order_by: { image_index: asc }, limit: 12) {
      id
      bucket_name
      file_name
    }
  }
`);

export const RENTAL_CMA_COHORTS = gql(/* GraphQL */ `
  query RentalCmaCohorts(
    $lat: Float!
    $lng: Float!
    $property_main_type: String!
    $computed_surface: Float
    $number_of_rooms: Float
    $rent_net_monthly: Float
    $limit: Int = 10
    $ch: Boolean!
    $es: Boolean!
    $fr: Boolean!
    $it: Boolean!
    $pl: Boolean!
    $pt: Boolean!
  ) {
    ch_get_similar_rental_listings_cohorts(
      args: {
        _lat: $lat
        _lng: $lng
        _property_main_type: $property_main_type
        _computed_surface: $computed_surface
        _number_of_rooms: $number_of_rooms
        _rent_net_monthly: $rent_net_monthly
        _limit: $limit
      }
    ) @include(if: $ch) {
      listing_id
      distance_in_meters
      listing {
        ...RentalCmaListingCh
      }
    }
    es_get_similar_rental_listings_cohorts(
      args: {
        _lat: $lat
        _lng: $lng
        _property_main_type: $property_main_type
        _computed_surface: $computed_surface
        _number_of_rooms: $number_of_rooms
        _rent_net_monthly: $rent_net_monthly
        _limit: $limit
      }
    ) @include(if: $es) {
      listing_id
      distance_in_meters
      listing {
        ...RentalCmaListingEs
      }
    }
    fr_get_similar_rental_listings_cohorts(
      args: {
        _lat: $lat
        _lng: $lng
        _property_main_type: $property_main_type
        _computed_surface: $computed_surface
        _number_of_rooms: $number_of_rooms
        _rent_net_monthly: $rent_net_monthly
        _limit: $limit
      }
    ) @include(if: $fr) {
      listing_id
      distance_in_meters
      listing {
        ...RentalCmaListingFr
      }
    }
    it_get_similar_rental_listings_cohorts(
      args: {
        _lat: $lat
        _lng: $lng
        _property_main_type: $property_main_type
        _computed_surface: $computed_surface
        _number_of_rooms: $number_of_rooms
        _rent_net_monthly: $rent_net_monthly
        _limit: $limit
      }
    ) @include(if: $it) {
      listing_id
      distance_in_meters
      listing {
        ...RentalCmaListingIt
      }
    }
    pl_get_similar_rental_listings_cohorts(
      args: {
        _lat: $lat
        _lng: $lng
        _property_main_type: $property_main_type
        _computed_surface: $computed_surface
        _number_of_rooms: $number_of_rooms
        _rent_net_monthly: $rent_net_monthly
        _limit: $limit
      }
    ) @include(if: $pl) {
      listing_id
      distance_in_meters
      listing {
        ...RentalCmaListingPl
      }
    }
    pt_get_similar_rental_listings_cohorts(
      args: {
        _lat: $lat
        _lng: $lng
        _property_main_type: $property_main_type
        _computed_surface: $computed_surface
        _number_of_rooms: $number_of_rooms
        _rent_net_monthly: $rent_net_monthly
        _limit: $limit
      }
    ) @include(if: $pt) {
      listing_id
      distance_in_meters
      listing {
        ...RentalCmaListingPt
      }
    }
  }
`);

export const RENTAL_CMA_LISTINGS_COUNT = gql(/* GraphQL */ `
  query RentalCmaListingsCount(
    $lat: Float!
    $lng: Float!
    $stateId: uuid
    $chWhere: ch_rental_cma_listings_distance_bool_exp!
    $esWhere: es_rental_cma_listings_distance_bool_exp!
    $frWhere: fr_rental_cma_listings_distance_bool_exp!
    $itWhere: it_rental_cma_listings_distance_bool_exp!
    $plWhere: pl_rental_cma_listings_distance_bool_exp!
    $ptWhere: pt_rental_cma_listings_distance_bool_exp!
    $ch: Boolean!
    $es: Boolean!
    $fr: Boolean!
    $it: Boolean!
    $pl: Boolean!
    $pt: Boolean!
  ) {
    ch_get_rental_cma_listings_distance_aggregate(
      args: { _lat: $lat, _lng: $lng, _state_id: $stateId }
      where: $chWhere
    ) @include(if: $ch) {
      aggregate {
        count
      }
    }
    es_get_rental_cma_listings_distance_aggregate(
      args: { _lat: $lat, _lng: $lng, _state_id: $stateId }
      where: $esWhere
    ) @include(if: $es) {
      aggregate {
        count
      }
    }
    fr_get_rental_cma_listings_distance_aggregate(
      args: { _lat: $lat, _lng: $lng, _state_id: $stateId }
      where: $frWhere
    ) @include(if: $fr) {
      aggregate {
        count
      }
    }
    it_get_rental_cma_listings_distance_aggregate(
      args: { _lat: $lat, _lng: $lng, _state_id: $stateId }
      where: $itWhere
    ) @include(if: $it) {
      aggregate {
        count
      }
    }
    pl_get_rental_cma_listings_distance_aggregate(
      args: { _lat: $lat, _lng: $lng, _state_id: $stateId }
      where: $plWhere
    ) @include(if: $pl) {
      aggregate {
        count
      }
    }
    pt_get_rental_cma_listings_distance_aggregate(
      args: { _lat: $lat, _lng: $lng, _state_id: $stateId }
      where: $ptWhere
    ) @include(if: $pt) {
      aggregate {
        count
      }
    }
  }
`);

export const RENTAL_CMA_MANUAL_LISTINGS = gql(/* GraphQL */ `
  query RentalCmaManualListings(
    $lat: Float!
    $lng: Float!
    $stateId: uuid
    $chWhere: ch_rental_cma_listings_distance_bool_exp!
    $esWhere: es_rental_cma_listings_distance_bool_exp!
    $frWhere: fr_rental_cma_listings_distance_bool_exp!
    $itWhere: it_rental_cma_listings_distance_bool_exp!
    $plWhere: pl_rental_cma_listings_distance_bool_exp!
    $ptWhere: pt_rental_cma_listings_distance_bool_exp!
    $limit: Int!
    $offset: Int = 0
    $ch: Boolean!
    $es: Boolean!
    $fr: Boolean!
    $it: Boolean!
    $pl: Boolean!
    $pt: Boolean!
  ) {
    ch_get_rental_cma_listings_distance(
      args: { _lat: $lat, _lng: $lng, _state_id: $stateId }
      where: $chWhere
      order_by: [{ listing: { valid_from: desc } }, { listing_id: desc }]
      limit: $limit
      offset: $offset
    ) @include(if: $ch) {
      listing_id
      distance_in_meters
      listing {
        ...RentalCmaListingCh
      }
    }
    es_get_rental_cma_listings_distance(
      args: { _lat: $lat, _lng: $lng, _state_id: $stateId }
      where: $esWhere
      order_by: [{ listing: { valid_from: desc } }, { listing_id: desc }]
      limit: $limit
      offset: $offset
    ) @include(if: $es) {
      listing_id
      distance_in_meters
      listing {
        ...RentalCmaListingEs
      }
    }
    fr_get_rental_cma_listings_distance(
      args: { _lat: $lat, _lng: $lng, _state_id: $stateId }
      where: $frWhere
      order_by: [{ listing: { valid_from: desc } }, { listing_id: desc }]
      limit: $limit
      offset: $offset
    ) @include(if: $fr) {
      listing_id
      distance_in_meters
      listing {
        ...RentalCmaListingFr
      }
    }
    it_get_rental_cma_listings_distance(
      args: { _lat: $lat, _lng: $lng, _state_id: $stateId }
      where: $itWhere
      order_by: [{ listing: { valid_from: desc } }, { listing_id: desc }]
      limit: $limit
      offset: $offset
    ) @include(if: $it) {
      listing_id
      distance_in_meters
      listing {
        ...RentalCmaListingIt
      }
    }
    pl_get_rental_cma_listings_distance(
      args: { _lat: $lat, _lng: $lng, _state_id: $stateId }
      where: $plWhere
      order_by: [{ listing: { valid_from: desc } }, { listing_id: desc }]
      limit: $limit
      offset: $offset
    ) @include(if: $pl) {
      listing_id
      distance_in_meters
      listing {
        ...RentalCmaListingPl
      }
    }
    pt_get_rental_cma_listings_distance(
      args: { _lat: $lat, _lng: $lng, _state_id: $stateId }
      where: $ptWhere
      order_by: [{ listing: { valid_from: desc } }, { listing_id: desc }]
      limit: $limit
      offset: $offset
    ) @include(if: $pt) {
      listing_id
      distance_in_meters
      listing {
        ...RentalCmaListingPt
      }
    }
  }
`);

export const RENTAL_CMA_LISTING_LOOKUP = gql(/* GraphQL */ `
  query RentalCmaListingLookup(
    $chWhere: ch_cma_rental_listings_bool_exp!
    $esWhere: es_cma_rental_listings_bool_exp!
    $frWhere: fr_cma_rental_listings_bool_exp!
    $itWhere: it_cma_rental_listings_bool_exp!
    $plWhere: pl_cma_rental_listings_bool_exp!
    $ptWhere: pt_cma_rental_listings_bool_exp!
    $limit: Int!
    $ch: Boolean!
    $es: Boolean!
    $fr: Boolean!
    $it: Boolean!
    $pl: Boolean!
    $pt: Boolean!
  ) {
    ch_cma_rental_listings(where: $chWhere, limit: $limit) @include(if: $ch) {
      id
    }
    es_cma_rental_listings(where: $esWhere, limit: $limit) @include(if: $es) {
      id
    }
    fr_cma_rental_listings(where: $frWhere, limit: $limit) @include(if: $fr) {
      id
    }
    it_cma_rental_listings(where: $itWhere, limit: $limit) @include(if: $it) {
      id
    }
    pl_cma_rental_listings(where: $plWhere, limit: $limit) @include(if: $pl) {
      id
    }
    pt_cma_rental_listings(where: $ptWhere, limit: $limit) @include(if: $pt) {
      id
    }
  }
`);

export const UPDATE_RENTAL_COMPARABLES = gql(/* GraphQL */ `
  mutation UpdateRentalComparables($id: uuid!, $rental_comparables: jsonb!) {
    update_cma_reports_by_pk(
      pk_columns: { id: $id }
      _set: { rental_comparables: $rental_comparables }
    ) {
      __typename
      id
      rental_comparables
      updated_at
    }
  }
`);

export const UPDATE_RENTAL_COMPARABLE_LISTINGS_MAP_ZOOM_LEVEL =
  gql(/* GraphQL */ `
    mutation UpdateRentalComparableListingsMapZoomLevel(
      $id: uuid!
      $rental_comparable_listings_map_zoom_level: Int
    ) {
      update_cma_reports_by_pk(
        pk_columns: { id: $id }
        _set: {
          rental_comparable_listings_map_zoom_level: $rental_comparable_listings_map_zoom_level
        }
      ) {
        id
        rental_comparable_listings_map_zoom_level
        updated_at
      }
    }
  `);

export const UPDATE_RENTAL_SHOW_FULL_DESCRIPTION = gql(/* GraphQL */ `
  mutation UpdateRentalShowFullDescription(
    $id: uuid!
    $show_full_rental_description: Boolean!
  ) {
    update_cma_reports_by_pk(
      pk_columns: { id: $id }
      _set: { show_full_rental_description: $show_full_rental_description }
    ) {
      id
      updated_at
      show_full_rental_description
    }
  }
`);

export const UPDATE_RENTAL_SHOW_COMPARABLE_LISTING_CARDS = gql(/* GraphQL */ `
  mutation UpdateRentalShowComparableListingCards(
    $id: uuid!
    $show_rental_comparable_listing_cards: Boolean!
  ) {
    update_cma_reports_by_pk(
      pk_columns: { id: $id }
      _set: {
        show_rental_comparable_listing_cards: $show_rental_comparable_listing_cards
      }
    ) {
      id
      updated_at
      show_rental_comparable_listing_cards
    }
  }
`);

export const UPDATE_RENTAL_COMPARABLES_SEARCH_PARAMS = gql(/* GraphQL */ `
  mutation UpdateRentalComparablesSearchParams(
    $id: uuid!
    $rental_comparables_search_params: jsonb!
  ) {
    update_cma_reports_by_pk(
      pk_columns: { id: $id }
      _set: {
        rental_comparables_search_params: $rental_comparables_search_params
      }
    ) {
      id
      rental_comparables_search_params
      updated_at
    }
  }
`);
